export default __webpack_public_path__ + "static/media/thumb-up.6ca40c96.svg";